import React from "react";
import {compose} from "redux";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {Image, ScrollView, StyleSheet, Text, TouchableOpacity, View} from "react-native";
import ChevronDroitMediumPicto from "../Picto/ChevronDroitMediumPicto";
import CheckActivePicto from "../Picto/CheckActivePicto";
import MyTheme from "../../Theme/Theme";

import { setLocale } from "react-redux-i18n";

class ReglageLangScreen extends React.Component{
    constructor(props) {
        super(props);
        this.setLang = this.setLang.bind(this);
    }

    componentDidMount() {
        this._setHeader();
    }

    componentDidUpdate() {
        this._setHeader();
    }

    _setHeader(){
        const styleHeaderGlobalWhite = {
            fontFamily: this.props.theme.fonts.title,
            backgroundColor : this.props.theme.colors.primary.White.value,
            height:80
        }  ;
        this.props.navigation.setOptions(
            {
                headerTitleAlign: "center",
                headerStyle: styleHeaderGlobalWhite,
                headerTitleStyle:{textTransform: 'capitalize'},
                title : this.props.t('Langue'),
                headerLeft : ()=><TouchableOpacity onPress={this.props.navigation.goBack}>
                    <Image resizeMode={"contain"} style={{width:20,height: 20,marginLeft:20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />
                </TouchableOpacity>
            }
        );
    }

     setLang(lng){

        this.props.i18n.changeLanguage(lng);
        const action = {'type' :'CHANGE_LANG','value' : lng};
        this.props.dispatch(action);
        this.props.navigation.navigate("Langue",{});
    }

    render() {
        const styles= StyleSheet.create({
            container:{
                paddingVertical:12,
                paddingHorizontal:20,
                flexDirection:"row",
                justifyContent:"space-between",
                alignItems:"center",
                borderBottomWidth:1,
                borderBottomColor:this.props.theme.colors.tertiary.black13.value,
                backgroundColor:this.props.theme.colors.primary.White.value
            } ,
            container_title:{
                backgroundColor:this.props.theme.colors.primary.blue5.value,
                color:this.props.theme.colors.primary.blue1.value
            },
            text:{
                fontFamily:this.props.theme.fonts.text_bold,
                color : this.props.theme.colors.tertiary.black3.value,
                fontSize:15,
                fontWeight:500
            },
            text_title:{
                color:this.props.theme.colors.primary.blue1.value
            },
            picto:{
                width:10,
                marginRight:10
            }
        });

        return (
            <ScrollView>
                <TouchableOpacity>
                    <View style={[styles.container,styles.container_title]}>
                        <Text style={[styles.text,styles.text_title]}>{this.props.t("Langue de l'application")}</Text>
                    </View>
                </TouchableOpacity>
                <TouchableOpacity onPress={()=>this.setLang("fr")}>
                    <View style={styles.container}>
                        <Text style={styles.text}>Français</Text>
                        { this.props.i18n.language == "fr" && <View ><CheckActivePicto isHeader={true} style={{width:26,height:26}} /></View> }
                    </View>
                </TouchableOpacity>

                <TouchableOpacity onPress={()=>this.setLang("en")}>
                    <View style={styles.container}>
                        <Text style={styles.text}>English</Text>
                        { this.props.i18n.language == "en" && <View ><CheckActivePicto isHeader={true} style={{width:26,height:26}} /></View> }
                    </View>
                </TouchableOpacity>

            </ScrollView>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(connect(mapStateToProps),withTranslation())(ReglageLangScreen);
